export enum FieldEnums {
  email = 'email',
  password = 'password',
}
